<template>
  <section class="desk-frame">
    <div class="head_row_calander bg--white flex relative no_mobile">
      <router-link
        class="head-link-blue head-link-back flex"
        :to="'/app-info/' + $route.params.id"
      >
        <img src="/assets/img/svg/arrow_r.svg" />
        חזרה
      </router-link>
      <div class="title title--40 no-marge tx--blue2 title-mid">
        סיכום ייעוץ רפואי
      </div>
      <div class="flex">
        <router-link class="bold" :to="'/app-info/' + $route.params.id"
          >ביטול</router-link
        >
        <a class="bt_blue bt-has" @click="onSave" href="javascript:void(0);"
          ><img src="/assets/img/svg/saved.svg" />שמירה</a
        >
      </div>
    </div>
    <menu-desktop class="no_mobile" />

    <div v-if="appointment" class="calandr_main flex flex--top add-summ-page">
      <div class="app_info_top">
        <div class="title">
          {{ appointment.firstName + " " + appointment.lastName }}
        </div>
        <div class="add_new_row flex">
          <div class="add_new_row_col1">ת.ז</div>
          <div class="add_new_row_col2 ft--400">{{ appointment.passport }}</div>
        </div>
        <div class="add_new_row flex">
          <div class="add_new_row_col1">תאריך לידה</div>
          <div class="add_new_row_col2 ft--400">
            {{
              $moment(appointment.birthDate, "YYYY-MM-DD").format("DD/MM/YYYY")
            }}
          </div>
        </div>
        <div class="add_new_row flex">
          <div class="add_new_row_col1">טלפון נייד</div>
          <div class="add_new_row_col2 ft--400">
            <div class="add_new_row_col2 ft--400">
              {{ appointment.phone }}
            </div>
          </div>
        </div>
        <div v-if="appointment.second_phone" class="add_new_row flex">
          <div class="add_new_row_col1">טלפון נוסף</div>
          <div class="add_new_row_col2 ft--400">
            {{ appointment.second_phone }}
          </div>
        </div>
        <div class="add_new_row flex">
          <div class="add_new_row_col1">שם הרופא</div>
          <div class="add_new_row_col2 ft--400">
            {{ doctor.title_surname ?? "" }} {{ doctor.heb_name }}
          </div>
        </div>
        <div class="add_new_row flex">
          <div class="add_new_row_col1">מרפאה</div>
          <div class="add_new_row_col2 ft--400">{{ appointment.address }}</div>
        </div>
        <div class="add_new_row flex">
          <div class="add_new_row_col1">מועד הייעוץ</div>
          <div class="add_new_row_col2 ft--400">
            {{
              $moment(new Date(appointment.start_datetime)).format(
                "D/MM/YY,  HH:mm  "
              )
            }}
          </div>
        </div>
      </div>
      <div v-if="questions" class="is--fit">
        <div
          v-for="(question, index) in questions"
          :key="index"
          class="add-summ-group"
        >
          <div class="book_surgery_top">{{ question.title }}</div>
          <div class="book_surgery_open">
            <div v-if="question.questions && question.questions.length">
              <template v-for="(q, i) in question.questions">
                <div
                  v-if="q.question_type === 'text'"
                  class="form_input"
                  :placeholder="q.question_text"
                  :key="i"
                >
                  <textarea v-model="q.answers[0].answer_value" />
                </div>
                <template v-if="q.question_type === 'signature'">
                  <div class="flex flex--top" :key="i">
                    <div class="app_info_top">
                      <div class="add_new_row flex">
                        <div class="add_new_row_col1">שם הרופא</div>
                        <div class="add_new_row_col2 ft--400">
                          {{ doctor.title_surname ?? "" }} {{ doctor.heb_name }}
                        </div>
                      </div>
                      <div class="add_new_row flex">
                        <div class="add_new_row_col1">התמחות</div>
                        <div class="add_new_row_col2 ft--400">
                          {{ doctor.job_title || "לא קיים במערכת" }}
                        </div>
                      </div>
                      <div class="add_new_row flex">
                        <div class="add_new_row_col1">מס׳ רישיון</div>
                        <div class="add_new_row_col2 ft--400">
                          {{ doctor.license || "לא קיים במערכת" }}
                        </div>
                      </div>
                    </div>
                    <div class="frame-sign-wrap">
                      <div class="frame-sign">
                        <img
                          v-if="signature"
                          :src="signature"
                          alt="signature"
                        />
                      </div>
                      <div class="center tx-400">חתימת הרופא</div>
                    </div>
                  </div>
                </template>
              </template>
              <div
                class="search-checks"
                v-if="
                  question.questions.length &&
                    question.questions.some(q => q.question_type == 'checkbox')
                "
              >
                <h3>הוספת הפניות לבדיקות</h3>
                <input
                  type="text"
                  v-model="search"
                  placeholder="חיפוש בדיקה/טיפול"
                />
              </div>
              <ul
                v-if="question.questions.length > 1"
                class="all-sum-checks flex"
              >
                <template v-for="(q, j) in question.questions">
                  <li
                    :key="j + 30"
                    v-if="
                      q.question_type === 'checkbox' && bySearch.includes(j)
                    "
                    class="form_check form_check-black"
                  >
                    <label>
                      <input
                        type="checkbox"
                        v-model="q.answers[0].answer_value"
                      />
                      {{ q.question_text }}
                      <span class="checkmark"></span>
                    </label>
                  </li>
                </template>
                <div v-if="!bySearch || !bySearch.length">אין תוצאות.</div>
              </ul>
            </div>
          </div>
        </div>
        <div class="error-message" v-if="msg">{{ msg }}</div>
        <div class="hold-savebt flex flex--content--center">
          <a class="bt_blue" @click="onSave" href="javascript:void(0);"
            >שמירה</a
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import Error from "@/components/Popups/Error";
import ConfirmAddSummary from "../../Popups/ConfirmAddSummary";

export default {
  components: { MenuDesktop },
  name: "AppAddSummery",
  data() {
    return {
      appointment: null,
      doctor: null,
      documents: [],
      questions: null,
      search: null,
      debounce: null,
      msg: null
    };
  },
  beforeMount() {
    this.$API.getAppointmentInfo(this.$route.params.id).then(res => {
      this.appointment = res.message.appointment;
      this.doctor = res.message.doctor;
      this.documents = res.message.documents;
    });
    this.$API.getAppSummeryQuestions().then(res => {
      this.questions = res.data.process_flow;
    });
  },
  computed: {
    ...mapGetters(["activeUser"]),
    signature() {
      const findD = this.activeUser.doctors.find(d => d.id === this.doctor.id);
      if (findD) return findD.signature;
      else return null;
    },
    bySearch() {
      let arr = [];
      const question = this.questions.find(qeu => {
        return qeu.questions.some(q => q.question_type == "checkbox");
      });

      if (!question) return arr;
      if (!this.search) {
        question.questions.forEach((q, i) => {
          arr.push(i);
        });
      } else {
        question.questions.forEach((q, i) => {
          const lowQT = q.question_text.toLowerCase();
          const lowSearch = this.search.toLowerCase();
          if (q.question_type === "checkbox" && lowQT.includes(lowSearch)) {
            arr.push(i);
          }
        });
      }
      return arr;
    }
  },
  methods: {
    baseSectionObject(page, title, value) {
      return {
        answers: [
          {
            name: "text",
            text: value,
            value: value,
            page_id: page,
            question_id: 0,
            question_text: "פירוט"
          }
        ],
        grouping_title: title
      };
    },
    baseCheckboxAnswer(page, q_id, value, question_text) {
      return {
        name: "checkbox",
        text: value,
        value: value,
        page_id: page,
        question_id: q_id,
        question_text: question_text
      };
    },
    async onSave() {
      this.msg = null;
      let valid = false;
      this.questions.forEach(q => {
        if (
          q.questions[0].question_type == "text" &&
          q.questions[0].answers[0].answer_value
        ) {
          valid = true;
        }
      });
      if (!valid) {
        this.msg = "יש למלא לפחות את אחד השדות";
        return;
      }
      let json = [];

      for (let i = 0; i < this.questions.length; i++) {
        if (!this.questions[i].questions || !this.questions[i].questions.length)
          continue;
        for (let j = 0; j < this.questions[i].questions.length; j++) {
          if (this.questions[i].questions[j].question_type == "text") {
            json.push(
              this.baseSectionObject(
                i,
                this.questions[i].title,
                this.questions[i].questions[j].answers[0].answer_value
              )
            );
          } else if (
            this.questions[i].questions[j].question_type == "checkbox"
          ) {
            if (!json[i]) {
              json.push(this.baseSectionObject(i, this.questions[i].title, ""));
            }
            const value = this.questions[i].questions[j].answers[0].answer_value
              ? 1
              : "";
            json[i].answers.push(
              this.baseCheckboxAnswer(
                i,
                j + 1,
                value,
                this.questions[i].questions[j].question_text
              )
            );
          }
        }
      }

      // signature
      json.push({
        answers: [
          {
            name: "signature",
            text: this.signature,
            value: this.signature,
            page_id: 3,
            question_id: "0",
            question_text: "חתימה"
          }
        ],
        grouping_title: "פרטי הרופא וחתימה"
      });

      try {
        await this.$API.sendAppSummery(
          this.appointment.id,
          JSON.stringify(json)
        );
        this.$modal.show(ConfirmAddSummary);
        this.msg = null;
      } catch (err) {
        this.$modal.show(Error);
      }
    }
  }
};
</script>
